import React from 'react';
import { Application } from '../../types';
import styles from './Chiclet.module.css';

interface ChicletProps {
  app: Application;
  onEdit?: (app: Application) => void;
}

const Chiclet: React.FC<ChicletProps> = ({ app, onEdit }) => {
  return (
    <div className={styles.chicletCard}>
      {onEdit && (
        <button className={styles.editBtn} onClick={() => onEdit(app)}>
          <i className="bi bi-pencil-fill"></i>
        </button>
      )}
      <a
        href={app.url}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.chicletContent}
        style={{ textDecoration: 'none' }}
      >
        <img src={app.logoUrl} alt={`${app.name} logo`} className={styles.chicletLogo} />
        <span className={styles.chicletName}>{app.name}</span>
      </a>
    </div>
  );
};

export default Chiclet;
